import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Box,
} from "@mui/material";
import axios from "axios";

const dialogPaperStyle = {
  borderRadius: "10px",
  padding: "1rem",
  width: "100%",
};

const CustomTextField = ({
  label,
  name,
  value,
  onChange,
  inputProps,
  disabled,
}) => (
  <Box mb={2}>
    <span style={{ fontSize: "13px" }}>{label}</span>
    <TextField
      name={name}
      placeholder={label}
      value={value}
      onChange={onChange}
      inputProps={inputProps}
      disabled={disabled}
      fullWidth
    />
  </Box>
);

export default function EditBillDialog({ isOpen, handleClose, rowData }) {
  const [formState, setFormState] = useState({
    name: rowData ? rowData.merchant.name : "",
    product: "",
    fee: rowData ? rowData.merchant.fee : "",
    type: "",
    mode: "",
    maxAmount: "",
  });

  useEffect(() => {
    if (rowData) {
      setFormState(rowData);
    }
  }, [rowData]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    // Implement the save logic here
    try {
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("userId");

      const payload = {
        ...formState,
        fee: parseFloat(formState.fee.replace("₦", "")),
        maxAmount: parseFloat(formState.maxAmount.replace("₦", "")),
      };

      await axios.post(
        `/api/admin/merchant/merchant/setprice?userId=${userId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      handleClose();
    } catch (error) {
      console.error(
        "Error saving charge data:",
        error.response || error.message
      );
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      PaperProps={{
        style: dialogPaperStyle,
      }}
    >
      <DialogTitle>Edit Bill</DialogTitle>
      <DialogContent>
        <CustomTextField
          label="Merchant Name"
          name="merchantName"
          value={formState.name}
          onChange={handleInputChange}
          InputProps={{ readOnly: true }}
          disabled
        />
        <CustomTextField
          label="Fee"
          name="fee"
          value={formState.fee}
          onChange={handleInputChange}
        />
        <CustomTextField
          label="Type"
          name="type"
          value={formState.type}
          onChange={handleInputChange}
        />
        <CustomTextField
          label="Mode"
          name="mode"
          value={formState.mode}
          onChange={handleInputChange}
        />
        <CustomTextField
          label="Max Amount"
          name="maxAmount"
          value={formState.maxAmount}
          onChange={handleInputChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
        <Button onClick={handleSave}>Update</Button>
      </DialogActions>
    </Dialog>
  );
}
